// extracted by mini-css-extract-plugin
module.exports = {"item":"_3FV8B","icon_wrapper":"XaJ4o","icon":"_10B4w","text":"_3lUE9","loading":"_1fIM5"};